
export function hasPermission(permissions, roleName, moduleName, action) {
  // Superadmin and admin have all permissions
  if (roleName === 'superadmin' || roleName === 'admin') return true;

  // For others: always allow add/view, edit/delete only if permission is given
  if (action === 'add' || action === 'view') return true;

  // For edit/delete, check permission
  const perm = permissions.find(p => p.module_name === moduleName);
  if (!perm) return false;
  return !!perm[`can_${action}`];
} 